export default {"src":"/_next/static/image/public/images/ic_download_app.4c4403f1651f4b9da6a3e29c16fff2c0.svg","height":16,"width":10};